<template>
    <svg data-name="check_circle_black_24dp (1)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path id="Path_448" data-name="Path 448" d="M0,0H24V24H0Z" fill="none"/>
        <path id="Path_449" data-name="Path 449" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM10,17,5,12l1.41-1.41L10,14.17l7.59-7.59L19,8Z" fill="#32aa00"/>
    </svg>
</template>
